import { render, staticRenderFns } from "./query-ranking-action-buttons.component.vue?vue&type=template&id=302ac080&scoped=true"
import script from "./query-ranking-action-buttons.component.vue?vue&type=script&lang=ts"
export * from "./query-ranking-action-buttons.component.vue?vue&type=script&lang=ts"
import style0 from "./query-ranking-action-buttons.component.vue?vue&type=style&index=0&id=302ac080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ac080",
  null
  
)

export default component.exports